import { formatDateByResolution } from "@productlane/lib/src/due-date"

import type { PillProps } from "./pill"
import { LinearDueDate } from "./due-date"
import { Tooltip } from "./tooltip"

interface DueDatePillProps {
	dueDate: string | null
	dueDateResolution?: string | null
	variant?: PillProps["variant"]
	iconClassName?: string
}

export function DueDatePill({
	dueDate,
	dueDateResolution,
	variant,
	iconClassName,
}: DueDatePillProps) {
	if (!dueDate) return null

	const formatTooltipDate = (
		dateString: string,
		resolution?: string | null,
	): string => {
		try {
			const date = new Date(dateString)
			if (isNaN(date.getTime())) {
				return dateString
			}
			return formatDateByResolution(date, resolution, { long: true })
		} catch {
			return dateString
		}
	}

	return (
		<Tooltip
			label={`This feature is being scheduled for ${formatTooltipDate(dueDate, dueDateResolution)}`}
			shouldWrapChildren
		>
			<div className="flex items-center gap-1">
				<LinearDueDate
					dueDate={dueDate}
					dueDateResolution={dueDateResolution}
					withIcon={true}
					variant={variant}
					iconClassName={iconClassName}
				/>
			</div>
		</Tooltip>
	)
}
